export default {
    "page": {
      "account_exists": {
        "text": "Het lijkt erop dat je al een account hebt.",
        "button": "Doorgaan naar mijn account"
      },
      "existing_page": {
        "title": "Kies een bestaand bedrijf.",
        "button": "Ga door met dit bedrijf"
      }
    },
    "success": "U bent nu geregistreerd!"
};